import type { UserRole } from '@socialsoup/shared';

export type PortalRole = 'admin' | 'client' | 'influencer' | 'agent';

export interface PortalConfig {
  label: string;
  hubName: string;
  accent: string;
  accentCssValue: string;
  gradient: string;
  basePath: string;
}

export const PORTAL_CONFIG: Record<PortalRole, PortalConfig> = {
  admin: {
    label: 'Admin',
    hubName: 'Admin Hub',
    accent: 'ss-yellow',
    accentCssValue: 'var(--ss-yellow)',
    gradient: 'from-ss-yellow to-ss-yellow-light',
    basePath: '/admin',
  },
  influencer: {
    label: 'Influencer',
    hubName: 'Creator Hub',
    accent: 'ss-pink',
    accentCssValue: 'var(--ss-pink)',
    gradient: 'from-ss-pink to-ss-pink-light',
    basePath: '/influencer',
  },
  client: {
    label: 'Client',
    hubName: 'Client Hub',
    accent: 'ss-blue',
    accentCssValue: 'var(--ss-blue)',
    gradient: 'from-ss-blue to-ss-blue-light',
    basePath: '/client',
  },
  agent: {
    label: 'Agent',
    hubName: 'Talent Hub',
    accent: 'ss-purple',
    accentCssValue: 'var(--ss-purple)',
    gradient: 'from-ss-purple to-ss-purple-light',
    basePath: '/agent',
  },
} as const;

export const ROLE_TO_PORTAL: Record<UserRole, string> = {
  ADMIN: '/admin',
  INFLUENCER: '/influencer',
  CLIENT: '/client',
  AGENT: '/agent',
};

export const ROLE_TO_PORTAL_ROLE: Record<UserRole, PortalRole> = {
  ADMIN: 'admin',
  INFLUENCER: 'influencer',
  CLIENT: 'client',
  AGENT: 'agent',
};
